<div class="material-datatables">
  <table
    [id]="table_id"
    class="table table-striped table-no-bordered table-hover"
    cellspacing="0"
    width="100%"
    style="width: 100%; overflow-x: auto; white-space: nowrap"
  >
    <thead>
      <tr>
        <th class="order" (click)="sort('id')">
          <i
            [ngStyle]="{ color: orderby === 'id' ? 'blue' : 'black' }"
            class="fa {{ sorting('id') }}"
          ></i
          ><b style="margin-left: 5px">Id</b>
        </th>
        <th class="order" (click)="sort('clientName')">
          <i
            [ngStyle]="{ color: orderby === 'clientName' ? 'blue' : 'black' }"
            class="fa {{ sorting('clientName') }}"
          ></i
          ><b style="margin-left: 5px">PO</b>
        </th>
        <th *ngIf="gui.permissions('tableProcessingClientName')" class="order">
          <i
            [ngStyle]="{ color: orderby === 'id' ? 'blue' : 'black' }"
            class="fa {{ sorting('id') }}"
          ></i
          ><b style="margin-left: 5px">Client Name</b>
        </th>
        <th class="order" (click)="sort('rep')">
          <i
            [ngStyle]="{ color: orderby === 'rep' ? 'blue' : 'black' }"
            class="fa {{ sorting('rep') }}"
          ></i
          ><b style="margin-left: 5px">Buyer</b>
        </th>
        <th class="order" (click)="sort('updated')">
          <i
            [ngStyle]="{ color: orderby === 'updated' ? 'blue' : 'black' }"
            class="fa {{ sorting('updated') }}"
          ></i
          ><b style="margin-left: 5px">Last Update</b>
        </th>
        <th class="order" (click)="sort('status')">
          <i
            [ngStyle]="{ color: orderby === 'status' ? 'blue' : 'black' }"
            class="fa {{ sorting('status') }}"
          ></i
          ><b style="margin-left: 5px">Status</b>
        </th>
        <th class="order" (click)="sort('isPaid')">
          <i
            [ngStyle]="{ color: orderby === 'isPaid' ? 'blue' : 'black' }"
            class="fa {{ sorting('isPaid') }}"
          ></i
          ><b style="margin-left: 5px">Payment Status</b>
        </th>
        <th class="order" (click)="sort('manifestfinished')">
          <i
            [ngStyle]="{
              color: orderby === 'manifestfinished' ? 'blue' : 'black'
            }"
            class="fa {{ sorting('manifestfinished') }}"
          ></i
          ><b style="margin-left: 5px">HDD Status</b>
        </th>
        <th class="order" (click)="sort('datefirstreceived')">
          <i
            [ngStyle]="{
              color: orderby === 'datefirstreceived' ? 'blue' : 'black'
            }"
            class="fa {{ sorting('datefirstreceived') }}"
          ></i
          ><b style="margin-left: 5px">Date Received</b>
        </th>
        <th class="order" (click)="sort('manifestprioritylevel')">
          <i
            [ngStyle]="{
              color: orderby === 'manifestprioritylevel' ? 'blue' : 'black'
            }"
            class="fa {{ sorting('manifestprioritylevel') }}"
          ></i
          ><b style="margin-left: 5px">Manifest</b>
        </th>
        <th class="order" (click)="sort('manifeststatus')">
          <i
            [ngStyle]="{
              color: orderby === 'manifeststatus' ? 'blue' : 'black'
            }"
            class="fa {{ sorting('manifeststatus') }}"
          ></i
          ><b style="margin-left: 5px">Manifest Status</b>
        </th>
        <th class="order" (click)="sort('testingprioritylevel')">
          <i
            [ngStyle]="{
              color: orderby === 'testingprioritylevel' ? 'blue' : 'black'
            }"
            class="fa {{ sorting('testingprioritylevel') }}"
          ></i
          ><b style="margin-left: 5px">Testing Priority Level</b>
        </th>
        <th class="order" (click)="sort('testingstatus')">
          <i
            [ngStyle]="{
              color: orderby === 'testingstatus' ? 'blue' : 'black'
            }"
            class="fa {{ sorting('testingstatus') }}"
          ></i
          ><b style="margin-left: 5px">Testing Status</b>
        </th>
        <th class="order" (click)="sort('sales')">
          <i
            [ngStyle]="{ color: orderby === 'sales' ? 'blue' : 'black' }"
            class="fa {{ sorting('sales') }}"
          ></i
          ><b style="margin-left: 5px">Sales Rep</b>
        </th>
        <th class="order" (click)="sort('manifest')">
          <i
            [ngStyle]="{ color: orderby === 'manifest' ? 'blue' : 'black' }"
            class="fa {{ sorting('manifest') }}"
          ></i
          ><b style="margin-left: 5px">Manifest Rep</b>
        </th>
        <th class="order" (click)="sort('tech')">
          <i
            [ngStyle]="{ color: orderby === 'tech' ? 'blue' : 'black' }"
            class="fa {{ sorting('tech') }}"
          ></i
          ><b style="margin-left: 5px">Tech Rep</b>
        </th>
        <th class="text-right"><b>Actionsd</b></th>
      </tr>
    </thead>
    <tbody>
      <tr style="cursor: pointer" *ngFor="let item of data">
        <td data-label="ID" (click)="saveEmit('show', item.id, item)">
          {{ item.id }}
        </td>
        <td data-label="PO" (click)="saveEmit('show', item.id, item)">
          <strong style="font-size: 2rem">{{ item.po.po }}</strong>
        </td>
        <td
          data-label="Client Name"
          *ngIf="gui.permissions('tableProcessingClientName')"
          (click)="saveEmit('show', item.id, item)"
        >
          {{ item.clientName }}
        </td>
        <td data-label="Buyer" (click)="saveEmit('show', item.id, item)">
          {{ item.rep.name }} {{ item.rep.surname }}
        </td>
        <td data-label="Last Update" (click)="saveEmit('show', item.id, item)">
          {{ item.updatedAt.timestamp * 1000 | date: "MM-dd-yyyy" }}
        </td>
        <td data-label="Status" (click)="saveEmit('show', item.id, item)">
          {{ status(item) }}
        </td>
        <td
          data-label="Payment Status"
          (click)="saveEmit('show', item.id, item)"
        >
          {{ paidStatus(item) }}
        </td>
        <td data-label="HDD Status" (click)="saveEmit('show', item.id, item)">
          <!--<span *ngIf="item.manifestFinished == 0">No Devices</span>
          <span *ngIf="item.manifestFinished == 1">In Progress</span>
          <span *ngIf="item.manifestFinished == 2">Completed</span>-->
          <span
            >{{ item.batchCompleted }} / {{ item.batchTotal }} Completed</span
          >
        </td>
        <td
          data-label="Date Received"
          (click)="saveEmit('show', item.id, item)"
        >
          <span *ngIf="item.dateFirstReceived !== null">{{
            item.dateFirstReceived.timestamp * 1000 | date: "MM-dd-yyyy"
          }}</span>
          <label *ngIf="item.dateFirstReceived === null">No date</label>
        </td>
        <td data-label="Manifest" (click)="saveEmit('show', item.id, item)">
          <span *ngIf="item.manifestRequired == 'Yes'">
            {{ showmanifest(item) }}
          </span>
          <span *ngIf="item.manifestRequired == 'No'">
            {{ item.noManifestPriorityLevel }}
          </span>
        </td>
        <td
          data-label="Manifest Status"
          (click)="saveEmit('show', item.id, item)"
        >
          {{ item.manifestStatus }}
        </td>
        <td
          data-label="Testing Priority Level"
          (click)="saveEmit('show', item.id, item)"
        >
          {{ testingPriorityLevel(item.poPriorityLevel) }}
        </td>
        <td
          data-label="Testing Status"
          (click)="saveEmit('show', item.id, item)"
        >
          {{ item.testingStatus }}
        </td>
        <td data-label="Sales Rep" (click)="saveEmit('show', item.id, item)">
          {{
            item.sales !== null
              ? item.sales.name[0] + item.sales.surname[0]
              : "--"
          }}
        </td>
        <td data-label="Manifest Rep" (click)="saveEmit('show', item.id, item)">
          {{
            item.manifest !== null
              ? item.manifest.name[0] + item.manifest.surname[0]
              : "--"
          }}
        </td>
        <td data-label="Tech Rep" (click)="saveEmit('show', item.id, item)">
          {{
            item.tech !== null ? item.tech.name[0] + item.tech.surname[0] : "--"
          }}
        </td>
        <td data-label="Actions" style="text-align: right">
          <a
            *ngIf="hasContainer(item)"
            class="btn btn-link btn-default btn-just-icon"
          >
            <i class="material-icons emitir" id="container-{{ item.id }}"
              >perm_scan_wifi</i
            >
          </a>

          <a
            *ngIf="item.chatLogs"
            class="btn btn-link btn-warning btn-just-icon"
          >
            <i class="material-icons emitir" id="chat-{{ item.id }}"
              >chat_bubble</i
            >
          </a>

          <a class="btn btn-link btn-info btn-just-icon">
            <i class="material-icons emitir" id="show-{{ item.id }}"
              >remove_red_eye</i
            >
          </a>

          <a class="btn btn-link btn-dark btn-just-icon">
            <i class="material-icons emitir" id="print-{{ item.id }}"
              >local_printshop</i
            >
          </a>

          <a
            class="btn btn-link btn-danger btn-just-icon"
            *ngIf="
              identity.role != 'VENDOR' &&
              identity.role != 'customer' &&
              item.status == 'INTRANSIT'
            "
          >
            <i class="material-icons emitir" id="delete-{{ item.id }}">close</i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<style>
  .order {
    cursor: pointer;
  }
</style>
